export var CalendarEventShowAs;
(function (CalendarEventShowAs) {
    CalendarEventShowAs[CalendarEventShowAs["Unknown"] = 0] = "Unknown";
    CalendarEventShowAs[CalendarEventShowAs["Free"] = 1] = "Free";
    CalendarEventShowAs[CalendarEventShowAs["Tentative"] = 2] = "Tentative";
    CalendarEventShowAs[CalendarEventShowAs["Busy"] = 3] = "Busy";
    CalendarEventShowAs[CalendarEventShowAs["OutOfOffice"] = 4] = "OutOfOffice";
    CalendarEventShowAs[CalendarEventShowAs["WorkingElsewhere"] = 5] = "WorkingElsewhere";
})(CalendarEventShowAs || (CalendarEventShowAs = {}));
